module.exports = __webpack_public_path__ + "img/instagram.26af878a.png";